import React, { useState } from "react";
import More from "../../TipjarSubscriptionModal/TipjarCheckoutForm/More";
import { distributeAlbum } from "../../../../../api/albums";
import { log_error } from "../../../../../api";

function DistributionModuleInfo({ albumId = "", handleClose, setDistributeAlbumSuccess, setDistributeAlbumError, onlyBack = false }) {
  const [seemore, setSeeMore] = useState(false);

  const startDistributing = async () => {
    if (albumId) {
      try {
        const { status, data } = await distributeAlbum(albumId);
        if (status === 200) setDistributeAlbumSuccess(data.success);
      } catch (error) {
        setDistributeAlbumError(log_error(error));
        console.log(log_error(error));
      }
    }
    window.open(process.env.REACT_APP_EVEARA_BASE_URL);
    handleClose();
  };

  const showSeeMore = () => {
    setSeeMore(true);
  };

  const onBack = () => {
    setSeeMore(false);
  };

  return seemore ? (
    <More onBack={onBack} />
  ) : (
    <div className="intro">
      <p>Hey Independent Artist,</p>

      <p>Now that you’re on board the Primo Plan, let’s give you a run down of exactly what kind of features you’ve unlocked.</p>
      <p>You can now distribute unlimited music on these platforms:</p>
      <p>
        • Amazon Prime Music <br /> • Apple Music <br /> • Bandcamp <br /> • Deezer <br /> • Facebook <br /> • Google Play <br /> • iHeart Radio{" "}
        <br /> • iTunes <br /> • Microsoft XBOX Groove <br /> • Siriux XM Pandora <br /> • SoundcCloud Go <br /> • Spotify <br /> • Tidal <br /> •
        TikTok ...
        <b className="seemore" onClick={showSeeMore}>
          {" "}
          and more{" "}
        </b>
      </p>
      <p>So what are you waiting for? It’s time to show the world what you’re made of. We all live to hear some good music.</p>

      {onlyBack ? (
        <button onClick={handleClose} className="my-3 btn btn-lg btn-primary text-white">
          <div className="text-uppercase">Back</div>
        </button>
      ) : (
        <button onClick={startDistributing} className="my-3 btn btn-lg btn-primary text-white">
          <div className="text-uppercase">Start Distributing</div>
        </button>
      )}
    </div>
  );
}

export default DistributionModuleInfo;
